module.exports = __webpack_public_path__ + "media/images/icons/flags/AM-1e16f07d7ec988524d3f72c251453f6e.svg";